import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=b3e6463c&"
import script from "./ArrowButton.vue?vue&type=script&lang=js&"
export * from "./ArrowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLeftLight: require('/vercel/path0/components/icons/ArrowLeftLight.vue').default})
